import { Button } from "@/components/ui/Button";
import type { PlanungAssignment } from "@/lib/montageplanung";

function formatRequestedAt(iso: string | null | undefined): string {
  if (!iso) return "—";
  const parsed = new Date(iso);
  if (Number.isNaN(parsed.getTime())) return iso;
  return parsed.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

function requesterLabel(assignment: PlanungAssignment): string {
  const login = assignment.monteur_proposal_by_login?.trim();
  if (!login) return "Monteur";
  return login;
}

export interface MonteurProposalApprovalCardProps {
  assignment: PlanungAssignment;
  onApprove: () => void;
  onReject: () => void;
  busy?: boolean;
  approving?: boolean;
  rejecting?: boolean;
}

export function MonteurProposalApprovalCard({
  assignment,
  onApprove,
  onReject,
  busy = false,
  approving = false,
  rejecting = false,
}: MonteurProposalApprovalCardProps) {
  const who = requesterLabel(assignment);

  return (
    <div className="rounded-ios-md border border-status-orange/35 bg-status-orange/10 px-3 py-3">
      <p className="text-[10px] font-semibold uppercase tracking-wide text-status-orange">
        Offener Terminantrag
      </p>
      <p className="mt-1 text-sm font-semibold text-label">
        Beantragt von {who}
      </p>
      <p className="mt-1 text-xs leading-relaxed text-label-secondary">
        {who} möchte „{assignment.title}" im Montageplan eintragen
        {(assignment.linked_assignment_ids?.length ?? 0) > 0
          ? ` (${assignment.linked_assignment_ids!.length + 1} Zeilen)`
          : ""}
        . Beantragt am {formatRequestedAt(assignment.monteur_proposal_at)}.
      </p>
      <div className="mt-3 flex flex-wrap justify-end gap-2">
        <Button
          type="button"
          variant="secondary"
          size="sm"
          loading={rejecting}
          disabled={busy}
          onClick={onReject}
        >
          Ablehnen
        </Button>
        <Button
          type="button"
          variant="primary"
          size="sm"
          loading={approving}
          disabled={busy}
          onClick={onApprove}
        >
          Annehmen
        </Button>
      </div>
    </div>
  );
}
